module.exports = __webpack_public_path__ + "static/media/skill_icon_royal_guard.cc95554c.png";